import { PrintConsignmentListPage } from "@/features/print-consignment/pages/PrintConsignmentListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/print-consignment/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["print_label.view_consignment"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PrintConsignmentListPage,
});
